import { OrganizationGroup } from 'src/domain/organization';

/**
 * Whole audiences stop at the second group level. Group events also allow
 * rooms at the third level of the organization hierarchy.
 */
export const excludeRoomGroupsFromAttendees = (
    groups: OrganizationGroup[],
): OrganizationGroup[] => {
    const groupById = new Map(groups.map(group => [group.id, group]));

    return groups.filter(group => {
        const parent = group.parentId
            ? groupById.get(group.parentId)
            : undefined;

        return !parent?.parentId || !groupById.has(parent.parentId);
    });
};

export const getTopSelectedEventGroupIds = (
    selectedIds: string[],
    groups: OrganizationGroup[],
): string[] => {
    const groupById = new Map(groups.map(group => [group.id, group]));
    const selected = new Set(selectedIds);

    return Array.from(selected).filter(id => {
        let parentId = groupById.get(id)?.parentId;
        const visited = new Set([id]);
        while (parentId && !visited.has(parentId)) {
            if (selected.has(parentId)) return false;
            visited.add(parentId);
            parentId = groupById.get(parentId)?.parentId;
        }
        return true;
    });
};

export const hasIndividualRoomSelection = (
    selectedIds: string[],
    groups: OrganizationGroup[],
): boolean => {
    const wholeAudienceIds = new Set(
        excludeRoomGroupsFromAttendees(groups).map(group => group.id),
    );
    return getTopSelectedEventGroupIds(selectedIds, groups).some(
        id => !wholeAudienceIds.has(id),
    );
};
